import { cloneDeep, uniqueId } from 'lodash';
import subjects from '@/constants/subjects';
import specialty from '@/constants/specialty';
import { reactive } from 'vue';
import { getCountry, getSpecialty, getSubjects } from '@/constants/utils/getValueById';
import urlParser from 'js-video-url-parser';
import VIDEO_PROVIDER from '@/constants/enums/videoProvider';

const inputs = [
  {
    autofocus: true,
    type: 'text',
    required: true,
    label: 'profile.forms.basic.inputs.firstName',
    modelName: 'firstName',
    modelValue: '',
    upperFirst: true,
    emptyError: 'errors.emptyName'
  },
  {
    type: 'text',
    required: true,
    label: 'profile.forms.basic.inputs.lastName',
    modelName: 'lastName',
    modelValue: '',
    upperFirst: true,
    emptyError: 'errors.emptyLastName',
    style: {
      gridColumn: '2'
    }
  },
  {
    type: 'countrySelect',
    required: true,
    label: 'profile.forms.basic.inputs.country',
    modelName: 'country',
    modelValue: {},
    emptyError: 'errors.emptyCountry',
    getValue: (model) => model.id,
    getFullObject: getCountry
  },
  {
    type: 'text',
    label: 'profile.forms.basic.inputs.city',
    modelName: 'city',
    modelValue: '',
    upperFirst: true,
    style: {
      gridColumn: '2'
    }
  },
  {
    type: 'select',
    required: true,
    label: 'profile.forms.basic.inputs.specialty',
    modelName: 'speciality',
    modelValue: specialty[0].id,
    keyProp: 'title',
    options: specialty,
    emptyError: 'errors.emptySpecialty',
    getValue: (val) => val.id,
    getFullObject: getSpecialty,
    style: {
      gridColumn: '1/3'
    }
  },
  {
    type: 'multiselect',
    required: true,
    label: 'profile.forms.basic.inputs.subjects',
    modelName: 'subjects',
    modelValue: [],
    keyProp: 'title',
    options: subjects,
    emptyError: 'errors.emptySubject',
    getValue: (val) => val.map((item) => item.id),
    getFullObject: getSubjects,
    style: {
      gridColumn: '1/3'
    }
  },
  {
    type: 'textarea',
    label: 'profile.forms.basic.inputs.aboutYourself',
    modelName: 'about',
    modelValue: '',
    style: {
      gridColumn: '1/3',
      height: '141px'
    }
  },
  {
    type: 'text',
    label: 'profile.forms.basic.video.label',
    info: 'profile.forms.basic.video.info',
    help: 'profile.forms.basic.video.help',
    modelName: 'presentationUrl',
    modelValue: '',
    validError: 'errors.notUrl',
    isValid: (url) => {
      if (!url) return true;
      const videoInfo = urlParser.parse(url) || {};
      return videoInfo.provider === VIDEO_PROVIDER.YOUTUBE || videoInfo.provider === VIDEO_PROVIDER.VIMEO;
    },
    style: {
      gridColumn: '1/3'
    }
  }
];

export default reactive(inputs.map((item) => {
  item.id = uniqueId('profile-input-');
  item.autocomplete = 'off';
  item.defaultValue = cloneDeep(item.modelValue);
  return item;
}));
